<template>
  <div class="checkAptitude">
    <div
      class="publicTitle display-flex justify-content-space-between align-items-center"
    >
      <h5 class="h5">
        <img src="../../assets/img/titleLine.png" alt /> 资质认证
      </h5>
    </div>
    <div class="mid" v-if="!isApprove">
      <div class="title">
        <h2>资质认证</h2>
        <p class="lineb"></p>
      </div>
      <div class="from">
        <Form
          class="head-login"
          ref="from"
          :model="userData"
          :rules="rules"
          :label-width="80"
          :hide-required-mark="true"
        >
          <FormItem label="姓名" prop="name">
            <Input
              type="text"
              v-model="userData.name"
              placeholder="请输入"
            ></Input>
          </FormItem>
          <FormItem label="资质类型" prop="type">
            <Select v-model="userData.type" placeholder="请选择资质类型">
              <Option value="初级会计">初级会计</Option>
              <Option value="中级会计">中级会计</Option>
              <Option value="高级会计">高级会计</Option>
            </Select>
          </FormItem>
          <FormItem label="证书编号" prop="zsnum">
            <Input
              type="text"
              v-model="userData.zsnum"
              placeholder="请输入"
            ></Input>
          </FormItem>
          <div id="save">
            <div class="display-flex">
              <FormItem>
                <Button
                  class="confirm"
                  type="primary"
                  :loading="btnLoading"
                  @click="handleSubmit('from')"
                  >确认</Button
                >
              </FormItem>
              <FormItem>
                <Button class="back" type="primary" @click="$router.back()"
                  >返回</Button
                >
              </FormItem>
            </div>
          </div>
        </Form>
      </div>
    </div>
    <div class="mid idSuccess" v-else>
      <img src="../../assets/img/approveSuc.png" alt="" />
      <span>已认证!</span>
      <i
        style=" display: inline-block;
      width: 250px;
      height: 1px;
      background: #ddd;
      margin-bottom: 29px;"
      ></i>
      <div class="info">
        <p class="name">
          {{ userInfo.name }}
          <i style="margin-left:10px">{{ userInfo.cztype }}</i>
        </p>
        <p class="idCode" v-if="userInfo.zsnum">
          {{
            `${userInfo.zsnum.slice(0, 5)}**********${userInfo.zsnum.slice(
              userInfo.zsnum.length - 3,
              userInfo.zsnum.length
            )}`
          }}
        </p>
      </div>
      <div class="from">
        <Form class="head-login" :label-width="80" :hide-required-mark="true">
          <div id="save">
            <div class="display-flex">
              <FormItem>
                <Button class="confirm" type="primary" @click="$router.back()"
                  >确认</Button
                >
              </FormItem>
              <FormItem>
                <Button class="back" type="primary" @click="$router.back()"
                  >返回</Button
                >
              </FormItem>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { postData, showLoading } from "../../assets/api/api.js";
export default {
  name: "checkAptitude",
  props: ["info"],
  components: {},
  data() {
    return {
      btnLoading: false,
      userInfo: {},
      isApprove: false,
      userData: {
        name: "",
        zsnum: "",
        type: "",
      },

      rules: {
        zsnum: [
          { required: true, message: "证书编号不能为空", trigger: "blur" },
          //   {
          //     pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          //     message: "身份证号格式不对",
          //   },
        ],
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        type: [
          { required: true, message: "资质类型不能为空", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.userInfo = {
      name: this.$route.query.name,
      cztype: this.$route.query.cztype,
      zsnum: this.$route.query.zsnum,
      idcard: this.$route.query.idcard,
      phone: this.$route.query.phone,
    };
    if (this.userInfo.cztype) {
      this.isApprove = true;
    } else {
      this.isApprove = false;
    }
  },
  mounted() {},
  computed: {},
  methods: {
    handleSubmit(name) {
      const { userData } = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          var params = {
            zsnum: userData.zsnum,
            cztype: userData.type,
            name: userData.name,
          };
          postData("student/update", params)
            .then((res) => {
              this.$Message.success("认证成功");
              this.btnLoading = false;
              this.isApprove = true;
              this.userInfo = res.data;
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style>
.checkAptitude .ivu-form-item:last-child .ivu-form-item-content {
  margin-left: 20px !important;
}
.checkAptitude #save {
  text-align: left;
}
.checkAptitude .ivu-input {
  height: 36px;
}
.checkAptitude .ivu-select-selection {
  text-align: left;
  height: 36px !important;
  line-height: 36px;
}
.ivu-select-placeholder {
  height: 36px !important;
  line-height: 36px;
}
.checkAptitude .send .ivu-form-item-content {
  margin-left: 0 !important;
}
.checkAptitude .send .ivu-btn-primary {
  color: rgba(153, 153, 153, 1);
  border: 1px solid #dedbde;
  background: #dddddd;
}
.checkAptitude .send button {
  height: 36px;
}
.checkAptitude .confirm {
  margin-top: 10px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  background: rgba(49, 175, 88, 1);
  border-radius: 4px;
  border: none;
}
.checkAptitude .back {
  background: rgba(34, 34, 34, 1);
  margin-top: 10px;
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  border: none;
}
</style>
<style lang="scss" scoped>
.checkAptitude {
  .idSuccess {
    .info {
      color: #999999;
      margin-bottom: 30px;
    }
    img {
      border: 1px dashed #aaa;
      margin-top: 115px;
    }
    span {
      display: block;
      color: #31af58;
      margin-bottom: 20px;
      margin-top: 5px;
    }
  }
  .mid {
    text-align: center;
    .lineb {
      display: inline-block;
      width: 26px;
      height: 2px;
      background: rgba(187, 187, 187, 1);
      margin-bottom: 40px;
    }
    h2 {
      margin-top: 110px;
      margin-bottom: 20px;
      font-size: 30px;
      color: rgba(34, 34, 34, 1);
    }
    .from {
      display: inline-block;
      margin-bottom: 115px;
      width: 480px;
      input {
        width: 50px;
      }
    }
  }
}
</style>
